<template>
  <pipeline-layout>
    <!--Main Content-->
    <table-paginated
      ref="completedPipelineTable"
      :load-data="loadCompletedRecords"
      :columns="columns"
      :per-page="50"
      :actions-width="100"
      empty-heading="No completed leads"
      entries-label="leads"
      is-empty-boxed
    >
      <template #emptyMessage>This is where the deals that you have completed will reside. You can control the lead statuses that show here in
        the
        <router-link :to="{name: 'settings', params: {tab: 'pipeline'}}">Pipeline Settings</router-link>
      </template>

      <template v-slot:actions="items">
        <button-link @click="openRecordModal(items.row.id)">View</button-link>
      </template>
    </table-paginated>

    <!--Filters-->
    <template #filters>
      <completed-filters :refresh="refresh"></completed-filters>
    </template>
  </pipeline-layout>
</template>

<script>
import PipelineLayout from "../../components/PipelineLayout";
import CompletedFilters from "./components/CompletedFilters";
import api from "../../../../api";
import TablePaginated from "../../../../components/table/TablePaginated";
import dates from "../../../../services/dates";
import router from "../../../../router";

export default {
  name: "CompletedPipelineDesktop",
  components: {CompletedFilters, PipelineLayout, TablePaginated},
  data() {
    const that = this;
    return {
      columns: [
        {
          label: "Status",
          display(row) {
            return that.getStatusLabel(row.current_status_id);
          }
        },
        {
          label: "Address",
          display(row) {
            return row.property.line_1;
          },
          isSensitiveDate: true,
        },
        {
          label: "City",
          display(row) {
            return row.property.city;
          },
          isSensitiveDate: true,
        },
        {
          label: "State",
          display(row) {
            return row.property.state;
          },
          isSensitiveDate: true,
        },
        {
          label: "Campaign",
          display(row) {
            return that.getCampaignLabel(row.campaign_id);
          }
        },
        {
          label: "Sale Closing Date",
          display(row) {
            return row.selling_info ? that.formatDate(row.selling_info.closing_at) : '--';
          }
        },
        {
          label: "Completed At",
          display(row) {
            return that.formatDate(row.entered_status_at);
          }
        },
      ],
    };
  },
  computed: {
    filters() {
      return this.$store.getters["completedState/filters"];
    },
  },
  methods: {
    openRecordModal(recordId) {
      router.replace({query: {lead: recordId}});
    },
    loadCompletedRecords(query = "") {
      const queryString = `&users=${this.filters.users}&status=${this.filters.statuses}&campaign=${this.filters.campaigns}&temperature=${this.filters.temperatures}&deal_probability=${this.filters.dealProbabilityScore}&${query}`;
      return api.records.getPipelineCompletedRecords(queryString);
    },
    refresh() {
      return this.$refs.completedPipelineTable.queryData();
    },
    getCampaignLabel(campaignId) {
      let campaign = this.$store.getters.campaigns.find(campaign => campaign.id === campaignId);
      return campaign ? campaign.label : null;
    },
    getStatusLabel(statusId) {
      let status = this.$store.getters["pipeline/completedStatuses"].find(status => status.id === statusId);
      return status ? status.label : null;
    },
    formatDate(date) {
      return dates.formatAsDate(date);
    },
  }
};
</script>

<style lang="scss" scoped>

</style>
